import React from 'react'
import { Alert, Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import NavBar from '../components/navbar'
import { setErrorState } from '../actions/api'

class ErrorScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            errorMessage: props.errorMessage,
            logoutErr: false,
        }
    }

    componentDidMount() {
        this.setState({ logoutErr: this.props.logoutErr });
        this.props.dispatch(setErrorState(false, null, false));
    }

    handleClick = () => {
        this.props.history.goBack();
    }

    renderSessionTimeout = () => {
        return (
            <div className="col" id="first">
                <Alert show={true} variant="danger">
                    <Alert.Heading>{this.props.strings.SESSION_TIMEOUT_ERROR_HEADER}</Alert.Heading>
                    <p>
                        {this.props.strings.SESSION_TIMEOUT_ERROR}<br/>
                    </p>
                    <hr />
                    <div className="d-flex justify-content-center">
                        <Button onClick={this.handleClick} variant="danger">
                            {this.props.strings.ERROR_HOME_LINK}
                        </Button>
                    </div>
                </Alert>
            </div>
        );
    }

    renderErrorMessage = () => {
        return(
            <div className="col" id="first">
                <Alert show={true} variant="danger">
                    <Alert.Heading>{this.props.strings.ERROR_HEADER}</Alert.Heading>
                    <p>
                        {this.props.strings.ERROR_PREFIX}<br/>
                        <b>{this.state.errorMessage}</b>
                    </p>
                    <hr />
                    <div className="d-flex justify-content-center">
                        <Button onClick={this.handleClick} variant="danger">
                            {this.props.strings.ERROR_HOME_LINK}
                        </Button>
                    </div>
                </Alert>
            </div>
        );
    }

    render() {
        // HTML here with bootstrap styles..
        let errorMessage = this.props.strings.BASIC_ERROR;
        return (
            <div className="container-full">
                <NavBar language={this.props.language}/>
                <div className="container">
                    <div className="col" id="first">
                        {this.state.logoutErr ? this.renderSessionTimeout() : this.renderErrorMessage()}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        language: state.language.language,
        errorMessage: state.api.errorMessage,
        logoutErr: state.api.logoutErr,
    }
}

const ConnectedErrorScreen = connect(
    mapStateToProps
)(ErrorScreen);
export default ConnectedErrorScreen;
